import React from "react";
import { FaRegSquare, FaSquare, FaThumbsDown, FaThumbsUp } from "react-icons/fa";
import Rating from "react-rating";

import { hotelRatings, hotelRatingsText } from "../utils";

const nf = new Intl.NumberFormat("de-DE");

export default function HotelRatings(props) {
  const { hotel } = props;

  let odd = true;


  return (
    <>
      {hotel &&
        hotel.HotelReview &&
        hotel.HotelReview.RatingsCount > 0 &&
        hotel.HotelReview.MeanRatings && (
          <>

            <div
              className="hotelratings"
              style={{
                backgroundColor: odd ? "#ffffff" : "#f0f0f0",
              }}
            >
              <div className="hotelratings1">Gesamtbewertung</div>
              <div className="hotelratings2">
                <Rating start={0} stop={6} emptySymbol={<FaRegSquare className="ratings" />}
                  fullSymbol={<FaSquare className="ratings" />} initialRating={hotel.HotelReview.MeanRatingOverall * 1} readonly />
                &nbsp;<span style={{ fontSize: "0.7em" }}>({nf.format(hotel.HotelReview.MeanRatingOverall)} von 6,0)</span>
                /
                {hotel.HotelReview.RatingsCount} Bewertungen
              </div>
            </div>
            <br />
            {hotel &&
              hotel.HotelReview &&
              hotel.HotelReview.MeanRatings &&
              Array.isArray(hotel.HotelReview.MeanRatings.MeanRating) &&
              hotel.HotelReview.MeanRatings.MeanRating.map((e) => {
                odd = !odd;
                return (
                  <div
                    className="hotelratings3"
                    style={{
                      backgroundColor: odd ? "#ffffff" : "#f0f0f0",
                    }}
                    key={e.RatingAttribute}
                  >
                    <div className="hotelratings4">
                      {hotelRatings.find((a) => e.RatingAttribute === a.value)
                        ? hotelRatings.find((a) => e.RatingAttribute === a.value).label
                        : e.RatingAttribute}
                    </div>
                    <div><Rating start={0} stop={6} emptySymbol={<FaRegSquare className="ratings" />}
                      fullSymbol={<FaSquare className="ratings" />} initialRating={e.value * 1} readonly />&nbsp;<span style={{ fontSize: "0.7em" }}>({nf.format(e.value)} von 6,0)</span></div>
                  </div>
                );
              })}
          </>
        )}

    </>
  );
}
